module.exports = {
  latestClaimsDate: new Date('2026-03-31'),
};
